import React, { useEffect, useState } from 'react';
import TableNew from 'RooV1.12/TableNew';
import request from '@/utils/request';
import { Pagination } from '@roo/roo';
import { ALIGN_TYPES } from '../../types';
import dayJs from 'dayjs';
import './index.scss';

interface IProps {
    wmPoiId: number;
}

const HistoryList: React.FC<IProps> = (props: IProps) => {
    const { wmPoiId } = props;

    // 分页
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [total, setTotal] = useState(0);

    // 运营人数据
    const [operationList, setOperationList] = useState<urls.distribute.OperationDetail[]>([]);

    // 列表项
    const columns = [
        {
            title: <span className="list-header">员工账号</span>,
            dataIndex: 'staffAcctId',
            align: ALIGN_TYPES.LEFT,
            width: 40,
            render(staffAcctId: any) {
                return <span className="list-content">{staffAcctId}</span>;
            },
        },
        {
            title: <span className="list-header">员工姓名</span>,
            dataIndex: 'staffName',
            align: ALIGN_TYPES.LEFT,
            width: 40,
            render(staffName: any) {
                return <span className="list-content">{staffName}</span>;
            },
        },
        {
            title: <span className="list-header">分配时间</span>,
            dataIndex: 'distribute',
            align: ALIGN_TYPES.CENTER,
            width: 20,
            render(ctime: any, record: any) {
                return (
                    <span className="list-content">
                        {dayJs(record.ctime * 1000).format('YYYY-MM-DD')}
                    </span>
                );
            },
        },
    ];

    // 获取历史运营人列表数据
    const getHistoryOprations = () => {
        request
            .get('/api/thirdpartnar/poi/distribution/distributed/history', {
                wmPoiId,
                pageNum,
                pageSize,
            })
            .then((res: urls.serverBase<urls.distribute.OperationList>) => {
                const { total, list } = res.data;
                setTotal(total);
                setOperationList(list);
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        getHistoryOprations();
    }, [wmPoiId, pageNum, pageSize]);

    return (
        <div className="operation-wrapper">
            <TableNew columns={columns} data={operationList} bordered />
            <div className="operation-pagination-right">
                <Pagination
                    total={total}
                    currentPage={pageNum}
                    pageSize={pageSize}
                    onChange={pageNum => setPageNum(pageNum)}
                />
            </div>
        </div>
    );
};

export default HistoryList;
